<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper/modules";

// CSS ضروري
import "swiper/css";
import "swiper/css/pagination";
</script>

<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <div
          class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
        >
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            {{ $t("common.app_name") }}
          </h1>
          <ul
            class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
          >
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">{{
                $t("common.home")
              }}</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">{{ $t("menu.home") }}</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!-- Additional actions here if needed -->
        </div>
      </div>
    </div>
    <!-- Content -->

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!-- Stories Section - Instagram/Facebook style at top -->
        <div v-if="isLoggedIn" class="stories-section mb-4">
          <StoriesList />
        </div>

        <div
          v-if="isloading == true"
          style="
            font-weight: 800;
            border-radius: 10px;
            padding: 50px;
            font-size: large;
            text-align: center;
            background: #73737326;
          "
          class="loader text-success"
        >
          {{ $t("common.loading") }}
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div class="col-md-12" v-if="isloading == false">
          <bannersHome />
        </div>
        <div class="row g-5 g-xl-8">
          <nearLiveV2 />
          <suggestLiveV2 />
          <qbankInfo v-if="isLoggedIn == true && isloading == false" />

          <div class="col-xl-4" v-if="isLoggedIn == true && isloading == false">
            <div class="card card-xl-stretch mb-5 mb-xl-8">
              <!-- Header -->
              <div class="card-header align-items-center border-0 mt-3">
                <h3 class="card-title align-items-start flex-column">
                  <span class="fw-bold text-dark fs-3">
                    <i
                      class="fas fa-wallet"
                      style="
                        border-radius: 10px;
                        padding: 8px 10px;
                        background: #1adc004f;
                        color: #16d71d;
                      "
                    ></i>
                    {{ $t("wallet.title") }}</span
                  >
                  <small class="text-gray-400 mt-2 fw-semibold fs-6">
                    {{ $t("wallet.balance_label") }}
                  </small>
                </h3>
              </div>

              <!-- Body -->
              <div class="card-body pt-5">
                <div class="d-flex mb-7">
                  <div
                    class="d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1"
                  >
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3"
                    >
                      <span
                        class="fs-5 text-gray-800 fw-bold"
                        style="font-weight: 700 !important"
                      >
                        <span v-if="loadingBalance">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </span>
                        <span v-else
                          >{{ walletBalance }} {{ $appCurrency }}</span
                        >
                      </span>
                      <span class="text-gray-400 fw-semibold fs-7 my-1">
                        {{ $t("wallet.hint") }}
                      </span>
                    </div>
                    <div class="text-end py-lg-0 py-2">
                      <span class="text-gray-400 fs-7 fw-semibold d-block">
                        <a href="Wallet" class="btn btn-success btn-sm"
                          >{{ $t("wallet.recharge") }}
                          <i class="fa fa-arrow-left"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Slide 2 -->
              </div>
            </div>
          </div>
          <!-- MIA AI Card - Compact Premium Design -->
          <div class="col-xl-4" v-if="isLoggedIn == true && isloading == false">
            <div class="mia-card-ultra">
              <!-- Decorative Elements -->
              <div class="mia-decor mia-decor-1"></div>
              <div class="mia-decor mia-decor-2"></div>
              
              <!-- Icon -->
              <div class="mia-ultra-icon">
                <div class="mia-icon-ring"></div>
                <div class="mia-icon-pulse"></div>
                <img src="/assets/img/mia_icon.png" alt="Mia AI" />
              </div>
              
              <!-- Text -->
              <div class="mia-ultra-text">
                <h4>{{ $t("menu.mia") }}</h4>
                <p>{{ $t("mia.subtitle") }}</p>
              </div>
              
              <!-- Button -->
              <a href="/ai-v2" class="mia-ultra-btn">
                <span>{{ $t("common.view") }}</span>
                <i class="fa fa-arrow-left ms-2"></i>
              </a>
            </div>
          </div>
          <div class="col-xl-4" v-if="isLoggedIn == true && isloading == false">
            <div class="card card-xl-stretch mb-5 mb-xl-8">
              <!-- Header -->
              <div class="card-header align-items-center border-0 mt-3">
                <h3 class="card-title align-items-start flex-column">
                  <span class="fw-bold text-dark fs-3">
                    <i
                      class="fas fa-play"
                      style="
                        border-radius: 10px;
                        padding: 8px 10px;
                        background: #8f9fff63;
                        color: #4a00ce;
                      "
                    ></i>
                    {{ $t("mycourses.title") }}
                  </span>
                  <small class="text-gray-400 mt-2 fw-semibold fs-6">
                    {{ $t("mycourses.subtitle") }}
                  </small>
                </h3>
              </div>

              <!-- Body -->
              <div class="card-body pt-5">
                <div class="d-flex mb-7">
                  <div
                    class="d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1"
                  >
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3"
                    >
                      <a
                        href="#"
                        class="fs-5 text-gray-800 text-hover-primary fw-bold"
                        style="font-weight: 700 !important"
                      >
                        <span v-if="loadingCourses">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </span>
                        <span v-else>{{ courseCount }}</span>
                      </a>
                      <span class="text-gray-400 fw-semibold fs-7 my-1">
                        {{ $t("mycourses.browse_hint") }}
                      </span>
                    </div>
                    <div class="text-end py-lg-0 py-2">
                      <span class="text-gray-400 fs-7 fw-semibold d-block">
                        <a href="Dashboard" class="btn btn-success btn-sm"
                          >{{ $t("common.view") }}
                          <i class="fa fa-arrow-left"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Slide 2 -->
              </div>
            </div>
          </div>
          <div class="col-xl-4" v-if="isLoggedIn == true && isloading == false">
            <div class="card card-xl-stretch mb-5 mb-xl-8">
              <!-- Header -->
              <div class="card-header align-items-center border-0 mt-3">
                <h3 class="card-title align-items-start flex-column">
                  <span class="fw-bold text-dark fs-3">
                    <i
                      class="fas fa-desktop"
                      style="
                        border-radius: 10px;
                        padding: 8px 10px;
                        background: #b4ffc5;
                        color: #000000;
                      "
                    ></i>
                    {{ $t("private_sessions.title") }}
                  </span>
                  <small class="text-gray-400 mt-2 fw-semibold fs-6">
                    {{ $t("private_sessions.subtitle") }}
                  </small>
                </h3>
              </div>

              <!-- Body -->
              <div class="card-body pt-5">
                <div class="d-flex mb-7">
                  <div class="symbol flex-shrink-0 me-4">
                    <img
                      src="assets/img/webinar.png"
                      class="mw-100"
                      style="height: 80px; width: 85px"
                      alt=""
                    />
                  </div>
                  <div
                    class="d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1"
                  >
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3"
                    >
                      <a
                        href="#"
                        class="fs-5 text-gray-800 text-hover-primary fw-bold"
                        style="font-weight: 700 !important"
                      >
                        <span>{{ $t("private_sessions.title") }}</span>
                      </a>
                      <span class="text-gray-400 fw-semibold fs-7 my-1">
                        {{ $t("private_sessions.browse_hint") }}
                      </span>
                    </div>
                    <div class="text-end py-lg-0 py-2">
                      <span class="text-gray-400 fs-7 fw-semibold d-block">
                        <a href="prvs" class="btn btn-success btn-sm"
                          >{{ $t("common.view") }}
                          <i class="fa fa-arrow-left"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Slide 2 -->
              </div>
            </div>
          </div>
          <div class="col-xl-4" v-if="isLoggedIn == true && isloading == false">
            <div class="card card-xl-stretch mb-5 mb-xl-8">
              <!-- Header -->
              <div class="card-header align-items-center border-0 mt-3">
                <h3 class="card-title align-items-start flex-column">
                  <span class="fw-bold text-dark fs-3">
                    <i
                      class="fas fa-university"
                      style="
                        border-radius: 10px;
                        padding: 8px 10px;
                        background: #cfffda;
                        color: #00a625;
                      "
                    ></i>
                    {{ $t("qbank.title") }}
                  </span>
                  <small class="text-gray-400 mt-2 fw-semibold fs-6">
                    {{ $t("qbank.subtitle") }}
                  </small>
                </h3>
              </div>

              <!-- Body -->
              <div class="card-body pt-5">
                <div class="d-flex mb-7">
                  <div class="symbol flex-shrink-0 me-4">
                    <img
                      src="assets/img/galaxy.png"
                      class="mw-100"
                      style="height: 80px; width: 85px"
                      alt=""
                    />
                  </div>
                  <div
                    class="d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1"
                  >
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3"
                    >
                      <a
                        href="#"
                        class="fs-5 text-gray-800 text-hover-primary fw-bold"
                        style="font-weight: 700 !important"
                      >
                        <span> {{ $t("qbank.title") }}</span>
                      </a>
                      <span class="text-gray-400 fw-semibold fs-7 my-1">
                        {{ $t("qbank.browse_hint") }}
                      </span>
                    </div>
                    <div class="text-end py-lg-0 py-2">
                      <span class="text-gray-400 fs-7 fw-semibold d-block">
                        <a href="qbank" class="btn btn-success btn-sm"
                          >{{ $t("common.view") }}
                          <i class="fa fa-arrow-left"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Slide 2 -->
              </div>
            </div>
          </div>
        </div>
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div
            class="col-md-12"
            v-if="isloading == false && isLoggedIn == false"
          >
            <infoDetails />
          </div>
          <div class="col-md-12" v-if="isloading == false">
            <h3 class="text-center section-title">
              {{ $t("home.featured_categories") }}
            </h3>
          </div>
          <div
            v-if="isloading == false"
            class="col-md-6 col-xxl-3 mt-2 section-cats"
            v-for="(category, index) in categories"
            :key="'category-' + index"
          >
            <!--begin::Card-->
            <div class="card">
              <!--begin::Card body-->
              <div class="card-body d-flex flex-center flex-column p-9">
                <!--begin::Wrapper-->
                <div class="mb-5">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-75px">
                    <a @click.prevent="openModal(category.subcategory)">
                      <img
                        :src="
                          category.cat_image
                            ? `${catImagePath}${category.cat_image}`
                            : defaultImage
                        "
                        @error="handleImageError"
                        :data-category-id="category.id"
                        :alt="category.name"
                      />
                    </a>
                  </div>
                  <!--end::Avatar-->
                </div>
                <!--end::Wrapper-->
                <!--begin::Name-->
                <a
                  href="#"
                  @click.prevent="openModal(category.subcategory)"
                  class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0"
                >
                  {{
                    $i18n.locale === "ar"
                      ? category.title.ar || category.title.en
                      : category.title.en
                  }}
                </a>

                <!--end::Name-->
                <!--begin::Position-->
                <div class="fw-semibold text-gray-400 mb-6">
                  {{
                    category.description ||
                    $t("home.category_default_description")
                  }}
                </div>
                <!--end::Position-->
                <!--begin::Link-->
                <!--<a :href="`/CategoryCourses?value_id=category_id&value=${category.id}`"
                  class="btn btn-sm btn-light-success fw-bold">
                  عرض <i class="fa fa-arrow-left"></i>
                </a>-->
                <!--end::Link-->
              </div>
              <!--end::Card body-->
            </div>
            <!--end::Card-->
          </div>
          <!--begin::Col-->
          <div class="col-sm-12 support" v-if="isloading == false">
            <!--begin::Address-->
            <div
              class="text-center bg-light card-rounded d-flex flex-column justify-content-center p-10 h-100"
            >
              <!--begin::Icon-->
              <!--begin::Svg Icon | path: icons/duotune/general/gen018.svg-->
              <span class="svg-icon svg-icon-3tx svg-icon-primary">
                <i class="bi bi-telegram"></i>
              </span>
              <!--end::Svg Icon-->
              <!--end::Icon-->
              <!--begin::Subtitle-->
              <h1 class="text-dark fw-bold my-5">{{ $t("common.support") }}</h1>
              <!--end::Subtitle-->
              <!--begin::Description-->
              <div class="text-gray-700 fs-3 fw-semibold">
                <a href="https://t.me/aca_demia" target="_blank">
                  0913103064 ( تليغرام)</a
                >
              </div>
              <!--end::Description-->
            </div>
            <!--end::Address-->
          </div>
          <!--end::Col-->
        </div>
      </div>
    </div>
    <!--begin::Col-->

    <!--end::Col-->
  </div>
  <!-- هيكل المودال -->
  <div
    class="modal fade"
    id="subCatsModal"
    tabindex="-1"
    aria-labelledby="subCatsModalLabel"
    aria-hidden="true"
    ref="subCatsModal"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <!-- عنوان المودال -->
        <div class="modal-header">
          <h5 class="modal-title" id="subCatsModalLabel">
            {{ $t("home.subcategories_title") }}
          </h5>
          <button
            type="button"
            class="btn-close"
            @click="closeModal"
            aria-label="{{ $t('common.close') }}"
          ></button>
        </div>
        <!-- محتوى المودال -->
        <div class="modal-body" ref="subCatContent">
          <!-- المحتوى سيتم ملؤه هنا -->
        </div>
        <!-- تذييل المودال (اختياري) -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            {{ $t("common.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
import infoDetails from "./infoDetails.vue";
import bannersHome from "./banners.vue";
import qbankInfo from "./qbankInfo.vue";
import nearLiveV2 from "./nearLiveV2.vue";
import nearSession from "./nearSession.vue";

import suggestLiveV2 from "./suggestLiveV2.vue";
import { walletState } from "@/stores/wallet";
import { StoriesList } from "@/components/stories";

export default {
  name: "Home",
  components: {
    infoDetails,
    nearLiveV2,
    qbankInfo,
    suggestLiveV2,
    bannersHome,
    nearSession,
    StoriesList,
  },
  data() {
    return {
      categories: [],
      subCategories: [],
      isloading: true,
      token: localStorage.getItem("access_token"),
      courseCount: 0,
      isLoggedIn: false,
      catImagePath: baseUrl + "/images/category/",
      defaultImage: "/assets/img/acad-icon.png",
      student: {},
      mobile: "0",
      loadingCategories: true, // Loading state for categories
      loadingCourses: true, // Loading state for courses
      // balance/loading come from centralized store
      tab: "nearLive", // لتحديد التاب النشط
      nearLiveStreams: [], // بيانات التاب الأول
      suggestLiveStreams: [], // بيانات التاب الثاني
      // Modal navigation state
      modalNavigationStack: [], // Stack to track navigation history
      currentModalTitle: "", // Current modal title
    };
  },
  computed: {
    activeTab() {
      if (this.nearLiveStreams.length > 0) return "near";
      if (this.suggestLiveStreams.length > 0) return "suggest";
      return "near"; // لو كلاهما فاضيين نعرض الأول كخيار افتراضي
    },
    walletBalance() {
      return walletState.walletBalance;
    },
    loadingBalance() {
      return walletState.loading;
    },
    isLoggedIn() {
      return walletState.isLoggedIn || !!localStorage.getItem("access_token");
    },
  },
  watch: {
    isloading(newVal) {
      if (newVal === false) {
        // DOM جاهز لتهيئة Flickity
      }
    },
  },
  mounted() {
    this.fetchCategories();
    if (this.token) {
      this.fetchStudentDetails();
    } else {
      this.isloading = false;
    }
    console.log(window.appRegion); // يجيبلك الريجون المختار كامل
    console.log(window.appCurrency); // يجيبلك العملة
  },
  methods: {
    openModal(subCategories, title = null) {
      // Reset navigation stack when opening fresh
      this.modalNavigationStack = [];
      this.currentModalTitle = title || this.$t("home.subcategories_title");

      // Render the subcategories
      this.renderModalContent(subCategories);

      // فتح المودال باستخدام Bootstrap
      const modalElement = new bootstrap.Modal(this.$refs.subCatsModal);
      modalElement.show();
    },

    renderModalContent(items) {
      const self = this;

      // Store items globally for click handlers
      window._modalItems = items;
      window._handleSubcategoryClick = (index) =>
        self.handleSubcategoryClick(index);
      window._navigateToSubcategory = (id, title) =>
        self.navigateToSubcategory(id, title);

      // Get translations
      const viewCoursesText =
        this.$i18n.locale === "ar" ? "عرض الدورات" : "View Courses";
      const moreText = this.$i18n.locale === "ar" ? "المزيد" : "More";
      const backText = this.$i18n.locale === "ar" ? "رجوع" : "Back";

      // بناء محتوى المودال على شكل بطاقات مع روابط
      const cardHTML = items
        .map((subCategory, index) => {
          // Check for children in both possible field names: childcategory (API) or children
          const childItems =
            subCategory.childcategory || subCategory.children || [];
          const hasChildren = childItems.length > 0;
          const title = subCategory.title || subCategory.name || "";

          // If has children, clicking card shows children. Otherwise clicking card goes to courses.
          const cardClickHandler = hasChildren
            ? `onclick="window._handleSubcategoryClick(${index})"`
            : `onclick="window._navigateToSubcategory(${
                subCategory.id
              }, '${title.replace(/'/g, "\\'")}')"`;

          return `
    <div class="col-md-4 col-sm-6 mb-4">
      <div class="subcategory-card ${
        hasChildren ? "has-children" : ""
      }" data-index="${index}" ${cardClickHandler}>
        <div class="subcategory-card-body">
          <h5 class="subcategory-card-title">${title}</h5>
          ${
            hasChildren
              ? `<span class="subcategory-children-badge"><i class="fas fa-chevron-down"></i> ${moreText}</span>`
              : ""
          }
        </div>
        <div class="subcategory-card-actions">
          <button class="subcategory-btn subcategory-btn-enter" onclick="event.stopPropagation(); window._navigateToSubcategory(${
            subCategory.id
          }, '${title.replace(/'/g, "\\'")}')">
            <i class="fas fa-play-circle text-white"></i> ${viewCoursesText}
          </button>
        </div>
      </div>
    </div>
  `;
        })
        .join("");

      // Back button if we have navigation history
      const backButton =
        this.modalNavigationStack.length > 0
          ? `
        <div class="modal-back-btn-container mb-3">
          <button class="modal-back-btn" onclick="window._goBackInModal && window._goBackInModal()">
            <i class="fas fa-arrow-right"></i> ${backText}
          </button>
        </div>
      `
          : "";

      // إضافة البطاقات إلى صف
      this.$refs.subCatContent.innerHTML = `
        ${backButton}
        <div class="row subcategory-grid">
          ${cardHTML}
        </div>
      `;

      // Update modal title
      const modalTitle = this.$refs.subCatsModal.querySelector(".modal-title");
      if (modalTitle) {
        modalTitle.textContent = this.currentModalTitle;
      }

      // Setup back navigation handler
      window._goBackInModal = () => this.goBackInModal();
    },

    handleSubcategoryClick(index) {
      const items = window._modalItems;
      if (!items || !items[index]) return;

      const subCategory = items[index];

      // Check for children in both possible field names: childcategory (API) or children
      const childItems =
        subCategory.childcategory || subCategory.children || [];

      // If has children, navigate into them
      if (childItems.length > 0) {
        // Push current state to stack
        this.modalNavigationStack.push({
          items: items,
          title: this.currentModalTitle,
        });

        // Update title and render children
        this.currentModalTitle = subCategory.title || subCategory.name || "";
        this.renderModalContent(childItems);
      }
    },

    navigateToSubcategory(id, title) {
      // Close modal and navigate to courses page
      this.closeModal();
      this.$router.push({
        path: "/courses",
        query: {
          subcategory_id: id,
          title: title,
        },
      });
    },

    goBackInModal() {
      if (this.modalNavigationStack.length === 0) return;

      // Pop the last state
      const previousState = this.modalNavigationStack.pop();
      this.currentModalTitle = previousState.title;
      this.renderModalContent(previousState.items);
    },

    closeModal() {
      // إغلاق المودال
      const modalElement = bootstrap.Modal.getInstance(this.$refs.subCatsModal);
      if (modalElement) {
        modalElement.hide();
      }
      // Clean up global handlers
      delete window._modalItems;
      delete window._handleSubcategoryClick;
      delete window._navigateToSubcategory;
      delete window._goBackInModal;
      this.modalNavigationStack = [];
    },
    async fetchCategories() {
      this.loadingCategories = true; // Start loading
      try {
        const response = await fetch(`${apiUrl}/home/web?v=2.0`, {
          method: "GET",
          headers: {
            "x-country-code": window.appRegion.phone_code,
          },
        });

        const jsonResponse = await response.json();
        this.categories = jsonResponse.allcategory;
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        this.loadingCategories = false; // Stop loading
      }
    },

    async fetchStudentDetails() {
      this.loadingCourses = true; // Start loading
      try {
        const response = await fetch(`${apiUrl}/desktop/my-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
            "x-country-code": window.appRegion.phone_code,
          },
        });

        if (response.ok) {
          const data = await response.json();
          this.student = data.student;
          this.mobile = data.student.mobile;
          this.courseCount = data.courses.length;
          this.isLoggedIn = true;
          this.isloading = false;
        } else if (response.status === 401 || response.status === 403) {
          //this.$router.push("/logout");
          this.isloading = false;
        } else {
          console.error("Failed to fetch student details");
          this.isloading = false;
        }
        this.isloading = false;
      } catch (error) {
        console.error("Error fetching student details:", error);
        //this.$router.push("/logout");
        this.isloading = false;
      } finally {
        this.loadingCourses = false; // Stop loading
      }
    },
    async getNearLive() {
      this.isLoadingStreams = true;
      try {
        const response = await fetch(
          `${apiUrl}/livestream/get-near-live-courses`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
              "x-country-code": window.appRegion.phone_code,
            },
          }
        );

        if (response.ok) {
          this.nearLiveStreams = await response.json();
        } else {
          console.error("Failed to fetch live streams");
        }
      } catch (error) {
        console.error("Error fetching live streams:", error);
      } finally {
        this.isLoadingStreams = false;
      }
    },

    async getsuggestLive() {
      this.isLoadingStreams = true;
      try {
        const response = await fetch(
          `${apiUrl}/livestream/get-similar-courses`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
              "x-country-code": window.appRegion.phone_code,
            },
          }
        );

        if (response.ok) {
          this.suggestLiveStreams = await response.json();
          console.log(this.suggestLiveStreams.length);
        } else {
          console.error("Failed to fetch live streams");
        }
      } catch (error) {
        console.error("Error fetching live streams:", error);
      } finally {
        this.isLoadingStreams = false;
      }
    },

    handleImageError(event) {
      // استبدال الصورة بصورة افتراضية إذا حدث خطأ مثل 404
      event.target.src = this.defaultImage;
    },
  },
};
</script>

<style scoped>
/* ========== Page Animation ========== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

/* ========== Toolbar ========== */
#kt_app_toolbar {
  background: linear-gradient(135deg, #f8fffe 0%, #f0fff5 100%);
  border-bottom: 1px solid rgba(0, 196, 68, 0.1);
  margin-bottom: 20px;
}

.page-heading {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 1.5rem !important;
  font-weight: 800 !important;
}

.breadcrumb-item a {
  color: #666;
  transition: all 0.3s ease;
}
.breadcrumb-item a:hover {
  color: #00c444;
}

/* ========== Loader ========== */
.loader {
  border-radius: 24px !important;
  background: linear-gradient(145deg, #f8fffe 0%, #f0fff5 100%) !important;
  border: 1px solid rgba(0, 196, 68, 0.1);
  box-shadow: 0 10px 40px rgba(0, 196, 68, 0.08);
  animation: pulse 1.5s ease-in-out infinite;
}
.loader .spinner-border {
  color: #00c444 !important;
}

/* ========== Cards ========== */
.card {
  border-radius: 20px !important;
  border: 1px solid rgba(0, 196, 68, 0.1) !important;
  background: linear-gradient(145deg, #ffffff 0%, #f8fffa 50%, #f0fff5 100%);
  box-shadow: 0 8px 32px rgba(0, 196, 68, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
  animation: fadeInUp 0.5s ease forwards;
  position: relative;
}
.card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #00c444, #00e050, #00c444);
  opacity: 0.8;
}
.card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 50px rgba(0, 196, 68, 0.15);
  border-color: rgba(0, 196, 68, 0.2) !important;
}

.card-header {
  background: transparent;
  border-bottom: 1px solid rgba(0, 196, 68, 0.08);
  padding: 20px 24px;
}

.card-title {
  margin-bottom: 0;
}
.card-title .fw-bold {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 1.1rem;
}
.card-title .fw-bold i {
  width: 42px;
  height: 42px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 12px !important;
  font-size: 1rem;
  transition: all 0.3s ease;
}
.card:hover .card-title .fw-bold i {
  transform: scale(1.1);
}

/* ========== Wallet Card Icon ========== */
.card-title .fa-wallet {
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e2 100%) !important;
  color: #00c444 !important;
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.2);
}

/* ========== Courses Card Icon ========== */
.card-title .fa-play {
  background: linear-gradient(135deg, #f0f0ff 0%, #e8e8ff 100%) !important;
  color: #6366f1 !important;
  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.2);
}

/* ========== Private Sessions Card Icon ========== */
.card-title .fa-desktop {
  background: linear-gradient(135deg, #fff0f0 0%, #ffe8e8 100%) !important;
  color: #ef4444 !important;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.2);
}

/* ========== QBank Card Icon ========== */
.card-title .fa-university {
  background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%) !important;
  color: #f59e0b !important;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.2);
}

.card-body {
  padding: 20px 24px;
}

/* ========== Card Values ========== */
.card-body .fs-5.fw-bold {
  font-size: 1.8rem !important;
  font-weight: 800 !important;
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ========== Buttons ========== */
.btn-success {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  color: #fff !important;
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.25);
  transition: all 0.3s ease !important;
  position: relative;
  overflow: hidden;
}
.btn-success:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.35) !important;
}
.btn-success::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}
.btn-success:hover::before {
  left: 100%;
}
.btn-success:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.35) !important;
}
.btn-success i {
  margin-right: 6px;
  transition: transform 0.3s ease;
}
.btn-success:hover i {
  transform: translateX(-3px);
}

/* ========== Section Title ========== */
.section-title {
  font-size: 1.8rem;
  font-weight: 800;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 30px;
  position: relative;
  display: inline-block;
  width: 100%;
}
.section-title::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #00c444, #00e050);
  border-radius: 2px;
}

/* ========== Category Cards ========== */
.section-cats .card {
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.section-cats .card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00c444, #00e050, #00c444);
  background-size: 200% 100%;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.section-cats .card:hover::before {
  opacity: 1;
  animation: shimmer 2s linear infinite;
}

.section-cats .symbol {
  margin-bottom: 16px;
}
.section-cats .symbol img {
  width: 80px !important;
  height: 80px !important;
  object-fit: cover;
  border-radius: 20px;
  border: 3px solid rgba(0, 196, 68, 0.1);
  padding: 8px;
  background: linear-gradient(145deg, #f8fffe 0%, #f0fff5 100%);
  transition: all 0.4s ease;
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.1);
}
.section-cats .card:hover .symbol img {
  transform: scale(1.1) rotate(5deg);
  border-color: rgba(0, 196, 68, 0.3);
  box-shadow: 0 12px 35px rgba(0, 196, 68, 0.2);
}

.section-cats .card .fs-4 {
  font-weight: 700 !important;
  color: #1a1a2e;
  transition: color 0.3s ease;
}
.section-cats .card:hover .fs-4 {
  color: #00c444;
}

.section-cats .card .fw-semibold {
  color: #666;
  font-size: 0.9rem;
}

/* ========== Support Section ========== */
.support {
  margin-top: 40px;
}
.support .card-rounded {
  border-radius: 24px !important;
  background: linear-gradient(145deg, #ffffff 0%, #f8fffe 100%) !important;
  border: 1px solid rgba(0, 196, 68, 0.12);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 196, 68, 0.08);
}
.support .card-rounded:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 50px rgba(0, 196, 68, 0.15);
  border-color: rgba(0, 196, 68, 0.2);
}

/* ========== Telegram Icon ========== */
.support .svg-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin: 0 auto 20px auto;
  background: linear-gradient(145deg, #0088cc 0%, #00aaee 100%);
  border-radius: 20px;
  box-shadow: 0 10px 35px rgba(0, 136, 204, 0.35),
    0 5px 15px rgba(0, 136, 204, 0.2);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.support .card-rounded:hover .svg-icon {
  transform: translateY(-6px) scale(1.05);
  box-shadow: 0 18px 50px rgba(0, 136, 204, 0.4),
    0 8px 25px rgba(0, 136, 204, 0.25);
}

.support .bi-telegram {
  font-size: 2.5rem !important;
  color: #fff !important;
  background: none !important;
  -webkit-background-clip: unset !important;
  -webkit-text-fill-color: #fff !important;
  background-clip: unset !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: auto !important;
  height: auto !important;
  line-height: 1 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  transition: transform 0.3s ease;
}

.support .bi-telegram::before {
  font-size: inherit;
  line-height: 1;
}

.support .card-rounded:hover .bi-telegram {
  transform: scale(1.1);
  box-shadow: none !important;
}

.support h1 {
  font-weight: 700 !important;
  font-size: 1.5rem !important;
  color: #1a1a2e;
  margin-bottom: 12px !important;
}

.support a {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #0088cc;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  text-decoration: none;
  padding: 10px 20px;
  background: rgba(0, 136, 204, 0.08);
  border-radius: 12px;
}
.support a:hover {
  color: #006699;
  background: rgba(0, 136, 204, 0.15);
  transform: translateY(-2px);
}

/* ========== Modal ========== */
.modal-content {
  border-radius: 24px !important;
  overflow: hidden;
  border: none;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15);
}

.modal-header {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  border: none;
  padding: 20px 24px;
}
.modal-title {
  color: #fff !important;
  font-weight: 700;
}
.btn-close {
  filter: brightness(0) invert(1);
}

/* Subcategories Modal Scroll Styles */
#subCatsModal .modal-dialog {
  max-height: 90vh;
}

#subCatsModal .modal-content {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

#subCatsModal .modal-header {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

#subCatsModal .modal-body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 60vh;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 196, 68, 0.4) transparent;
}

#subCatsModal .modal-body::-webkit-scrollbar {
  width: 6px;
}

#subCatsModal .modal-body::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

#subCatsModal .modal-body::-webkit-scrollbar-thumb {
  background: linear-gradient(
    180deg,
    rgba(0, 196, 68, 0.4) 0%,
    rgba(0, 164, 60, 0.4) 100%
  );
  border-radius: 10px;
}

#subCatsModal .modal-body::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(
    180deg,
    rgba(0, 196, 68, 0.6) 0%,
    rgba(0, 164, 60, 0.6) 100%
  );
}

#subCatsModal .modal-footer {
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.modal-body {
  padding: 24px;
  background: linear-gradient(145deg, #f8fffe 0%, #ffffff 100%);
}

.modal-footer {
  background: linear-gradient(145deg, #f8fffe 0%, #ffffff 100%);
  border-top: 1px solid rgba(0, 196, 68, 0.1);
  padding: 16px 24px;
}
.modal-footer .btn-secondary {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%) !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 10px 24px !important;
  font-weight: 600 !important;
}

/* ========== Swiper ========== */
.mySwiper {
  width: 100%;
  padding-bottom: 30px;
}

.swiper-pagination {
  bottom: 0px !important;
}

.swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background: rgba(0, 196, 68, 0.3);
  opacity: 1;
  transition: all 0.3s ease;
}

.swiper-pagination-bullet-active {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  width: 24px;
  border-radius: 5px;
}

/* ========== Spinner ========== */
.spinner-border {
  color: #00c444 !important;
}

/* ========== Images ========== */
.symbol img {
  border-radius: 16px;
  transition: all 0.3s ease;
}

/* ========== Responsive ========== */
@media (max-width: 768px) {
  .card {
    border-radius: 16px !important;
  }
  .section-title {
    font-size: 1.4rem;
  }
  .section-cats .symbol img {
    width: 60px !important;
    height: 60px !important;
  }
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] #kt_app_toolbar,
[data-theme="dark"] #kt_app_toolbar,
.dark #kt_app_toolbar {
  background: linear-gradient(135deg, #1a1b1d 0%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .page-heading,
[data-theme="dark"] .page-heading,
.dark .page-heading {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-bs-theme="dark"] .loader,
[data-theme="dark"] .loader,
.dark .loader {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%) !important;
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .card,
[data-theme="dark"] .card,
.dark .card {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%);
  border-color: rgba(0, 196, 68, 0.1) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
[data-bs-theme="dark"] .card:hover,
[data-theme="dark"] .card:hover,
.dark .card:hover {
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  border-color: rgba(0, 196, 68, 0.2) !important;
}

[data-bs-theme="dark"] .card-header,
[data-theme="dark"] .card-header,
.dark .card-header {
  border-color: rgba(0, 196, 68, 0.1);
}

[data-bs-theme="dark"] .card-title .fw-bold,
[data-bs-theme="dark"] .card-title .text-dark,
[data-theme="dark"] .card-title .fw-bold,
[data-theme="dark"] .card-title .text-dark,
.dark .card-title .fw-bold,
.dark .card-title .text-dark {
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .text-gray-400,
[data-theme="dark"] .text-gray-400,
.dark .text-gray-400 {
  color: #b0b3b8 !important;
}

[data-bs-theme="dark"] .text-gray-800,
[data-theme="dark"] .text-gray-800,
.dark .text-gray-800 {
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .section-title,
[data-theme="dark"] .section-title,
.dark .section-title {
  background: linear-gradient(135deg, #e4e6eb 0%, #b0b3b8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-bs-theme="dark"] .section-cats .symbol img,
[data-theme="dark"] .section-cats .symbol img,
.dark .section-cats .symbol img {
  background: linear-gradient(145deg, #2d2e30 0%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .section-cats .card .fs-4,
[data-theme="dark"] .section-cats .card .fs-4,
.dark .section-cats .card .fs-4 {
  color: #e4e6eb;
}
[data-bs-theme="dark"] .section-cats .card:hover .fs-4,
[data-theme="dark"] .section-cats .card:hover .fs-4,
.dark .section-cats .card:hover .fs-4 {
  color: #00e050;
}

[data-bs-theme="dark"] .support .card-rounded,
[data-theme="dark"] .support .card-rounded,
.dark .support .card-rounded {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%) !important;
  border-color: rgba(0, 136, 204, 0.2);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
}

[data-bs-theme="dark"] .support a,
[data-theme="dark"] .support a,
.dark .support a {
  color: #00bbff;
  background: rgba(0, 136, 204, 0.15);
}
[data-bs-theme="dark"] .support a:hover,
[data-theme="dark"] .support a:hover,
.dark .support a:hover {
  color: #00ddff;
  background: rgba(0, 136, 204, 0.25);
}

[data-bs-theme="dark"] .support h1,
[data-theme="dark"] .support h1,
.dark .support h1 {
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .support .svg-icon,
[data-theme="dark"] .support .svg-icon,
.dark .support .svg-icon {
  background: linear-gradient(145deg, #0099dd 0%, #00ccff 100%);
  box-shadow: 0 10px 35px rgba(0, 153, 221, 0.4),
    0 5px 15px rgba(0, 153, 221, 0.25);
}

[data-bs-theme="dark"] .support .card-rounded:hover .svg-icon,
[data-theme="dark"] .support .card-rounded:hover .svg-icon,
.dark .support .card-rounded:hover .svg-icon {
  box-shadow: 0 18px 50px rgba(0, 153, 221, 0.45),
    0 8px 25px rgba(0, 153, 221, 0.3);
}

[data-bs-theme="dark"] .support .bi-telegram,
[data-theme="dark"] .support .bi-telegram,
.dark .support .bi-telegram {
  color: #fff !important;
  background: none !important;
  box-shadow: none !important;
}

[data-bs-theme="dark"] .modal-body,
[data-theme="dark"] .modal-body,
.dark .modal-body {
  background: linear-gradient(145deg, #1a1b1d 0%, #242526 100%);
}

[data-bs-theme="dark"] .modal-footer,
[data-theme="dark"] .modal-footer,
.dark .modal-footer {
  background: linear-gradient(145deg, #1a1b1d 0%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .swiper-pagination-bullet,
[data-theme="dark"] .swiper-pagination-bullet,
.dark .swiper-pagination-bullet {
  background: rgba(0, 196, 68, 0.4);
}
</style>

<!-- Non-scoped styles for dynamically injected modal content -->
<style>
/* ========== SUBCATEGORY MODAL STYLES (Global) ========== */
.subcategory-grid {
  padding: 10px 0;
}

.subcategory-card {
  background: linear-gradient(145deg, #ffffff 0%, #f8fffa 100%);
  border: 2px solid rgba(0, 196, 68, 0.15);
  border-radius: 16px;
  padding: 20px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.subcategory-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 196, 68, 0.15);
  border-color: rgba(0, 196, 68, 0.3);
}

.subcategory-card.has-children {
  border-color: rgba(17, 57, 84, 0.2);
}

.subcategory-card.has-children:hover {
  border-color: rgba(17, 57, 84, 0.4);
  box-shadow: 0 12px 30px rgba(17, 57, 84, 0.15);
}

.subcategory-card-body {
  flex: 1;
  text-align: center;
  margin-bottom: 15px;
}

.subcategory-card-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 8px;
  line-height: 1.4;
}

.subcategory-children-badge {
  display: inline-block;
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e4 100%);
  color: #00a43c;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
  margin-top: 5px;
}

.subcategory-card-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.subcategory-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.subcategory-btn i {
  font-size: 12px;
}

.subcategory-btn-enter {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  color: #fff;
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.25);
}

.subcategory-btn-enter:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 196, 68, 0.35);
}

.subcategory-btn-children {
  background: linear-gradient(135deg, #113954 0%, #1a4d6e 100%);
  color: #fff;
  box-shadow: 0 4px 15px rgba(17, 57, 84, 0.25);
}

.subcategory-btn-children:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(17, 57, 84, 0.35);
}

.modal-back-btn-container {
  padding: 0 5px;
}

.modal-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
  border: 1px solid #d0d0d0;
  border-radius: 10px;
  color: #333;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modal-back-btn:hover {
  background: linear-gradient(135deg, #e0e0e0 0%, #d0d0d0 100%);
  transform: translateX(3px);
}

.modal-back-btn i {
  font-size: 12px;
}

/* Dark mode for subcategory modal */
[data-bs-theme="dark"] .subcategory-card,
[data-theme="dark"] .subcategory-card,
.dark .subcategory-card {
  background: linear-gradient(145deg, #2d2e30 0%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.2);
}

[data-bs-theme="dark"] .subcategory-card:hover,
[data-theme="dark"] .subcategory-card:hover,
.dark .subcategory-card:hover {
  border-color: rgba(0, 196, 68, 0.4);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
}

[data-bs-theme="dark"] .subcategory-card-title,
[data-theme="dark"] .subcategory-card-title,
.dark .subcategory-card-title {
  color: #e4e6eb;
}

[data-bs-theme="dark"] .subcategory-children-badge,
[data-theme="dark"] .subcategory-children-badge,
.dark .subcategory-children-badge {
  background: linear-gradient(135deg, #0d3320 0%, #134e2a 100%);
  color: #4ade80;
}

[data-bs-theme="dark"] .modal-back-btn,
[data-theme="dark"] .modal-back-btn,
.dark .modal-back-btn {
  background: linear-gradient(135deg, #3d3d3d 0%, #2d2d2d 100%);
  border-color: #4d4d4d;
  color: #e4e6eb;
}

[data-bs-theme="dark"] .modal-back-btn:hover,
[data-theme="dark"] .modal-back-btn:hover,
.dark .modal-back-btn:hover {
  background: linear-gradient(135deg, #4d4d4d 0%, #3d3d3d 100%);
}

/* MIA Card Ultra Premium Design */
.mia-card-ultra {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  padding: 28px 24px;
  margin-bottom: 20px;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(16, 185, 129, 0.1);
}

.mia-card-ultra:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(16, 185, 129, 0.18);
  border-color: rgba(16, 185, 129, 0.25);
}

/* Decorative Elements */
.mia-decor {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  opacity: 0.5;
  transition: all 0.5s ease;
}

.mia-decor-1 {
  width: 100px;
  height: 100px;
  top: -50px;
  right: -30px;
  background: radial-gradient(circle, rgba(16, 185, 129, 0.12) 0%, transparent 70%);
}

.mia-decor-2 {
  width: 80px;
  height: 80px;
  bottom: -30px;
  left: -20px;
  background: radial-gradient(circle, rgba(5, 150, 105, 0.1) 0%, transparent 70%);
}

.mia-decor-1 {
  animation: mia-decor-float-1 6s ease-in-out infinite;
}

.mia-decor-2 {
  animation: mia-decor-float-2 7s ease-in-out infinite;
}

@keyframes mia-decor-float-1 {
  0%, 100% { transform: scale(1) translate(0, 0); opacity: 0.5; }
  50% { transform: scale(1.2) translate(5px, 5px); opacity: 0.7; }
}

@keyframes mia-decor-float-2 {
  0%, 100% { transform: scale(1) translate(0, 0); opacity: 0.4; }
  50% { transform: scale(1.3) translate(-5px, -5px); opacity: 0.6; }
}

/* Icon with Effects */
.mia-ultra-icon {
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
}

/* Rotating Ring */
.mia-icon-ring {
  position: absolute;
  inset: -6px;
  border-radius: 22px;
  border: 2px dashed rgba(16, 185, 129, 0.35);
  animation: mia-ring-rotate 8s linear infinite;
}

@keyframes mia-ring-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Pulse Effect */
.mia-icon-pulse {
  position: absolute;
  inset: 0;
  border-radius: 18px;
  background: rgba(16, 185, 129, 0.12);
  animation: mia-pulse 2.5s ease-in-out infinite;
}

@keyframes mia-pulse {
  0%, 100% { transform: scale(1); opacity: 0.3; }
  50% { transform: scale(1.15); opacity: 0.5; }
}

.mia-ultra-icon img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 18px;
  background: #f8faf9;
  padding: 12px;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.2);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.mia-card-ultra:hover .mia-ultra-icon img {
  transform: scale(1.05) translateY(-2px);
  box-shadow: 0 10px 30px rgba(16, 185, 129, 0.3);
}

/* Text */
.mia-ultra-text {
  margin-bottom: 18px;
}

.mia-ultra-text h4 {
  margin: 0 0 6px 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.3;
}

.mia-ultra-text p {
  margin: 0;
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.4;
}

/* Button */
.mia-ultra-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 24px;
  background: #27446f;
  color: white;
  font-weight: 600;
  font-size: 0.95rem;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(39, 68, 111, 0.3);
}

.mia-ultra-btn:hover {
  background: #1e3557;
  color: white;
  transform: scale(1.02);
  box-shadow: 0 6px 20px rgba(39, 68, 111, 0.4);
  text-decoration: none;
}

.mia-ultra-btn i {
  transition: transform 0.3s ease;
}

.mia-ultra-btn:hover i {
  transform: translateX(-4px);
}

/* Dark Mode */
[data-bs-theme="dark"] .mia-card-ultra,
[data-theme="dark"] .mia-card-ultra,
.dark .mia-card-ultra {
  background: #1f2937;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

[data-bs-theme="dark"] .mia-card-ultra:hover,
[data-theme="dark"] .mia-card-ultra:hover,
.dark .mia-card-ultra:hover {
  box-shadow: 0 12px 35px rgba(16, 185, 129, 0.25);
}

[data-bs-theme="dark"] .mia-ultra-text h4,
[data-theme="dark"] .mia-ultra-text h4,
.dark .mia-ultra-text h4 {
  color: #f3f4f6;
}

[data-bs-theme="dark"] .mia-ultra-text p,
[data-theme="dark"] .mia-ultra-text p,
.dark .mia-ultra-text p {
  color: #9ca3af;
}
</style>
